import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MatChipsModule } from '@angular/material/chips';
import { ShareDirectivesModule } from '../../../core/directives/directives.module';
import { TranslationModule } from '../../../i18n/translation.module';
import { MaterialModule } from '../../modules/material/material.module';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { ModalTitleComponent } from '../modal-title/modal-title.component';

@NgModule({
  declarations: [ConfirmDialogComponent],
  imports: [
    CommonModule,
    MaterialModule,
    TranslationModule,
    FormsModule,
    ShareDirectivesModule,
    MatChipsModule,
    ModalTitleComponent
  ],
  exports: [ConfirmDialogComponent],
})
export class ConfirmDialogModule { }
